import { Dispatch } from 'react'
import { HISTORIAL_TYPES } from '../../constants/historial.types'
import { ErrorsHFilterForm, HFilterForm, HistorialAction } from '../../interfaces/historial.interface'
import { validateFilterOnBlur } from '../../utils/invoice/validateFilter'
import { generalOpenModalError, generalOpenModalInfo, generalOpenModalMessage, generalShowLoader } from '../general.actions'
import { ENDPOINTS } from '../../api/config'
import * as http from "../../api/http";
import { KEYS } from '../../constants/keysStorage'
import { setAnuladoFactura, setItemsFacturasAnular, setResultAnulaciones, setResultFacturasFilter, setStatusModalAnular, setTiposDocumentos } from './historial.actions'
import { validarRegexNumEnteroGuion, validarRegexNumIdentificacion, validarRegexNumericoInt, validarRegexSoloLetrasEspacio } from '../../utils/strings.utils'
import { State } from '../../reducers'
import { getFechaCA } from '../../utils/stringDate'

// ******************************************************************************************

export const historialFilterChangeForm = (formHistorial: any) => ({
  type: HISTORIAL_TYPES.HISTORIAL_FORMFILTER_CHANGE,
  payload: formHistorial,
})

export const historialFilterErrorChange = (formErrors: any) => ({
  type: HISTORIAL_TYPES.HISTORIAL_SET_ERRORS_FILTER,
  payload: formErrors,
})

export const historialSetFilterSearch = (formHistorial: any) => ({
  type: HISTORIAL_TYPES.HISTORIAL_SAVE_SEARCH_FORMFILTER,
  payload: formHistorial,
})

export const historialSetActivePage = (pagina: number) => ({
  type: HISTORIAL_TYPES.HISTORIAL_SET_ACTIVE_PAGE,
  payload: pagina,
})

export const historialSetTotalPages = (total: number) => ({
  type: HISTORIAL_TYPES.HISTORIAL_SET_TOTALS_PAGES,
  payload: total,
})

// ******************************************************************************************
export const historialFilterHandleChangeForm = 
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => 
  async (dispatch: Dispatch<HistorialAction>) => {
    let { name, value } = e.target;
    let shouldDispatch = true;

    switch (name) {
      case 'nit':
        shouldDispatch = validarRegexNumEnteroGuion(value);
        break;
      
      case 'nombreReceptor':
        shouldDispatch = validarRegexSoloLetrasEspacio(value);
        break;

      case 'nrcEmisor':
      case 'nrcReceptor':
        shouldDispatch = validarRegexNumericoInt(value);
        break;
      
      case 'tipoDocCliente':
        dispatch(historialFilterChangeForm({[name]: value, documento: ''}));
        dispatch(historialFilterErrorChange({documento: ''}));
        return;
    
      case 'documento':
        shouldDispatch = validarRegexNumIdentificacion(value);
        break;

      default:
        break;
    }

    if (shouldDispatch) {
      dispatch(historialFilterChangeForm({ [name]: value }));
    }
  };

export const historialFilterHandleErrors = 
  (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
    form: HFilterForm,
    errors: ErrorsHFilterForm,
    docs: Array<any>,
  ) => 
  async (dispatch: Dispatch<HistorialAction>) => {
    let {name, value} = e.target;
    const resErrors = validateFilterOnBlur({...form, [name]: value}, name, {...errors}, docs);
   
    dispatch(historialFilterErrorChange(resErrors));
  }


export const getTransactions =
  (formFilter: HFilterForm, page: number = 0, updateData: boolean = false) => async (dispatch: Dispatch<any>, getState: () => State) => {
    dispatch(generalShowLoader(true));
    const {arrayFacturas} = getState().historial;

    return await http
      .post(ENDPOINTS.GET_HISTORIAL_TRANSACCIONES, 
        {
          fechaInicio: formFilter.fechaInicial || "-1",
          fechaFin: formFilter.fechaFinal || "-1",
          tipoDoc: formFilter.tipoDocCliente || "-1",
          nit_emisor: formFilter.nit.replace(/-/g, "") || "-1", 
          nrc_receptor: formFilter.nrcReceptor || "-1",
          nrc_emisor: formFilter.nrcEmisor || "-1",
          doc_receptor: formFilter.documento?.replace(/-/g, "") || "-1",
          tipodte: formFilter.tipoDTE,
          NombreCompleto: formFilter.nombreReceptor.trim() || "-1",
          offset: page,
          tokenGateway: localStorage.getItem(KEYS.TOKEN),
        }, {}, KEYS.TOKEN
      )
      .then(async (res: any) => {
        if (Array.isArray(res?.body)) {
          const dteOrdenados = res.body.map((el: any) => {
            const fechaCompleta = new Date(`${el.DetallesDTE?.identificacion?.fecEmi}T${el.DetallesDTE?.identificacion?.horEmi}`);
            return { ...el, fechaCompleta, pagina: page };
          });
          dteOrdenados.sort((a:any, b:any) => b.fechaCompleta - a.fechaCompleta);     
          
          // Caso cuando solo actualiza
          if (updateData) {
            const otraData = arrayFacturas.filter((fact) => fact.pagina !== page);
            dispatch(setResultFacturasFilter([...otraData, ...dteOrdenados]));
            return true;
          }
          if (page === 0) {
            // Nueva busqueda
            dispatch(setResultFacturasFilter(dteOrdenados));
            dispatch(historialSetTotalPages(dteOrdenados[0]?.Paginas));
          } else {
            // Paginacion agregar datos
            dispatch(setResultFacturasFilter([...arrayFacturas, ...dteOrdenados]));
          }
          dispatch(historialSetActivePage(page));
          return true;
        } else {
          dispatch(setResultFacturasFilter([]));
          dispatch(generalOpenModalInfo('No hay resultados encontrados'))
          return false;
        }
      })
      .catch(async (err: any) => {
        if (err?.response?.data?.errorCode === 1) {
          await dispatch(generalOpenModalInfo(err?.response?.data?.message ?? 'No hay resultados encontrados'))
        } else {
          await dispatch(generalOpenModalError(err?.response?.data?.message ?? 'Error al buscar resultados, intente nuevamente', err?.response?.data?.status))
        }
        dispatch(setResultFacturasFilter([]));
        return false;
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

  export const getDocById =
  (correlativo: string, codigoGeneracion: string, loader: boolean = true) => async (dispatch: Dispatch<any>) => {
    if (loader) dispatch(generalShowLoader(true));

    return await http
      .post(ENDPOINTS.GET_HISTORIAL_TRANSACCIONES, 
        {
          fechaInicio: "-1", fechaFin: "-1",
          tipoDoc: "-1", NombreCompleto: "-1",
          nit_emisor: "-1", tipodte: "-1",
          nrc_receptor: "-1", nrc_emisor: "-1", doc_receptor: "-1",
          Excel: false,
          codigoGeneracion: codigoGeneracion,
          correlativo: correlativo,
          tokenGateway: localStorage.getItem(KEYS.TOKEN),
        }, {}, KEYS.TOKEN
      )
      .then(async (res: any) => {
        return res.body;
      })
      .catch(async (err: any) => {
        if (err?.response?.data?.errorCode === 1) {
          await dispatch(generalOpenModalInfo(err?.response?.data?.message ?? 'No se encontro el documento'))
        } else {
          await dispatch(generalOpenModalError(err?.response?.data?.message ?? 'Error al obtener el documento, intente nuevamente', err?.response?.data?.status))
        }
        return false;
      })
      .finally(() => (loader) && dispatch(generalShowLoader(false)))
  }

export const getTiposDocumentos =
  () => async (dispatch: Dispatch<HistorialAction>) => {
    dispatch(generalShowLoader(true));
    return await http
      .get(ENDPOINTS.GET_HISTORIAL_TIPOS_DOCUMENTOS)
      .then(async (res: any) => {
        if (res.body) {
          dispatch(setTiposDocumentos(res.body));
          return true;
        } else {
          dispatch(generalOpenModalError('No hay documentos disponibles para realizar operaciones'))
          return false;
        }
      })
      .catch(async (err: any) => {
        let message = 'Error al cargar catalogo de documentos, intente nuevamente'
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
        return false;
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const historialHandleAnulaciones = 
  () => 
  async (dispatch: Dispatch<HistorialAction>, getState: () => State) => {
    const {activeFactura, resultAnulaciones} = getState().historial;

    // Anulacion unitaria
    if (activeFactura || resultAnulaciones.length === 1) {
      dispatch(setAnuladoFactura(resultAnulaciones[0].result));
      if (resultAnulaciones[0].result) dispatch(generalOpenModalMessage(`Anular documento`, `Documento anulado exitosamente.`))
      else dispatch(generalOpenModalError(resultAnulaciones[0].msg))
    } else {  
      // Anulaciones multiples
      const excepciones = resultAnulaciones.filter((res) => !res.result);
      if (excepciones.length > 0) {
        let msg = `Anulación finalizada, los siguientes documentos presentaron errores: <br/><br/>`;
        msg += excepciones.map((res) => `${res.doc} - ${res.msg}`).join("<br/><br/>");
        dispatch(generalOpenModalInfo(msg));
      } else {
        dispatch(generalOpenModalMessage(`Anular documento`, `Documentos anulados exitosamente.`))
      }
      // Actualizar listado
      dispatch(setItemsFacturasAnular([]));
    }
    dispatch(setResultAnulaciones([]));
    dispatch(setStatusModalAnular(false));
  }


export const downloadExcel = () => async (dispatch: Dispatch<any>, getState: () => State) => {
  if(getState().general.loader) return;
  const formFilter: HFilterForm = getState().historial.formFilter;
  dispatch(generalShowLoader(true));
  await http.post(ENDPOINTS.GET_HISTORIAL_TRANSACCIONES, 
      {
        fechaInicio: formFilter.fechaInicial || "-1",
        fechaFin: formFilter.fechaFinal || "-1",
        tipoDoc: formFilter.tipoDocCliente || "-1",
        nit_emisor: formFilter.nit.replace(/-/g, "") || "-1", 
        nrc_receptor: formFilter.nrcReceptor || "-1",
        nrc_emisor: formFilter.nrcEmisor || "-1",
        doc_receptor: formFilter.documento?.replace(/-/g, "") || "-1",
        tipodte: formFilter.tipoDTE,
        NombreCompleto: formFilter.nombreReceptor.trim() || "-1",
        tokenGateway: localStorage.getItem(KEYS.TOKEN),
        Excel: true,
      }, {}, KEYS.TOKEN)
    .then(async (res: any) => {
      if (Array.isArray(res?.body)) {
        dispatch(generalOpenModalInfo('Proceso iniciado correctamente.'))
        // const posExcel:any = res?.body.at(-1);
        // if(posExcel?.Excel) {
        //   let today = new Date().toLocaleDateString('en-CA')
        //   today = getFechaCA(today)
        //   today = today.replaceAll("/", "-");
        //   let element = document.createElement("a");
        //   let typeFile = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";        
        //   element.setAttribute("href", typeFile + encodeURIComponent(posExcel.Excel));
        //   element.setAttribute("download", `HistorialDeDocumentos_${today}.xlsx`);
        //   element.style.display = "none";
        //   document.body.appendChild(element);
        //   element.click();
        //   document.body.removeChild(element);
        // }
        return;
      }       
      dispatch(generalOpenModalInfo('No hay resultados encontrados'))      
    })
    .catch((err: any) => {
      if (err?.response?.data?.errorCode === 1) dispatch(generalOpenModalInfo(err?.response?.data?.message ?? 'No hay resultados encontrados'))
      else dispatch(generalOpenModalError(err?.response?.data?.message ?? 'Error al obtener resultados, intente nuevamente', err?.response?.data?.status))      
    })
    .finally(() => dispatch(generalShowLoader(false)))
}